import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { FormModalUpsellProps } from './types';

const FormModalUpsellUserPlan = React.lazy(() => import('userPlan/FormModalUpsell'));

const fallbackRender = (): JSX.Element => null;
export const FormModalUpsell = ({
  isOpen,
  feature,
  onClose,
  handleFormModal,
  toggleFormModal,
}: FormModalUpsellProps) => (
  <ErrorBoundary onReset={() => null} fallbackRender={fallbackRender} data-testid="error-boundary">
    <Suspense fallback={null}>
      <FormModalUpsellUserPlan
        isOpen={isOpen}
        feature={feature}
        onClose={onClose}
        handleFormModal={handleFormModal}
        toggleFormModal={toggleFormModal}
      />
    </Suspense>
  </ErrorBoundary>
);
